<!-- 
	This is the DataTables page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  
	<div>
		<!-- Searchable Datatable card -->
		<a-row type="flex" :gutter="24">
			<a-col :span="12" class="mb-24">
				<a-button type="primary" @click="$router.push('newassociation')">NEW ASSOCIATION</a-button>
			</a-col>
			<a-col :span="12" class="mb-24 text-right">
				<a-dropdown >
					<a-button class="ant-dropdown-link">
						FILTERS <a-icon class="ml-5" type="down" />
					</a-button>
					<a-menu slot="overlay">
						<a-menu-item key="0">
							<a href="http://www.alipay.com/">Active</a>
						</a-menu-item>
						<a-menu-item key="2">
							<a href="http://www.taobao.com/">Not Active</a>
						</a-menu-item>
					</a-menu>
				</a-dropdown>
				<a-button @click="csvExport(csvData)" class="ml-15">
					<i class="ni ni-archive-2 mr-5"></i> EXPORT CSV
				</a-button>

			</a-col>
		</a-row>
		<a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">
			<div class="mx-25">
				<a-row type="flex" :gutter="24">
					<a-col :span="24" :md="12">
						<a-select v-model="pageSize2" @change="onPageSize2Change" style="width: 70px">
							<a-select-option value="5">5</a-select-option>
							<a-select-option value="10">10</a-select-option>
							<a-select-option value="15">15</a-select-option>
							<a-select-option value="20">20</a-select-option>
							<a-select-option value="25">25</a-select-option>
						</a-select>
						<label for="" class="ml-10">entries per page</label>
					</a-col>
					<a-col :span="24" :md="12" class="text-right">
    					<a-input-search placeholder="smart search" style="max-width: 200px;" v-model="query" @change="onSearchChange" />
					</a-col>
				</a-row>
			</div>
			
			<a-table class="mt-20" :columns="columns" :data-source="data" :pagination="{pageSize: pageSize2,}">	
				<template slot="editBtn" slot-scope="row">
					
					<a-tooltip>
						<template slot="title">Update Vendor</template>
							<a-button @click="$router.push({name: 'HomeOwners Edit', params: {id: row.id}})">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path class="fill-gray-7" d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z"/>
								<path class="fill-gray-7" d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z"/>
							</svg>
						</a-button>
					</a-tooltip>
				</template>
				<template slot="deleteBtn" slot-scope="row">
					<a-tooltip>
						<template slot="title">Delete HomeOwner</template>
						<!-- <modalDelete @deleteHomeOwner="deleteHomeOwner" :row="row" /> -->
					</a-tooltip>
				</template>
			</a-table>
		</a-card>
		<!-- / Searchable Datatable card -->
		
	</div>
</template>

<script>

const columns = [
		{
			title: 'ASSOCIATION NAME',
			dataIndex: 'associationName',
			sorter: (a, b) => a.associationName.length - b.associationName.length,
			sortDirections: ['descend', 'ascend'],
		},
		{
			title: 'STATUS',
			dataIndex: 'status',
			sorter: (a, b) => a.status.length - b.status.length,
			sortDirections: ['descend', 'ascend'],
		},
		
		{
			title: 'WEBSITE',
			dataIndex: 'website',
			sorter: (a, b) => a.website.length - b.website.length,
			sortDirections: ['descend', 'ascend'],
		},
		
		
		
		{
			title: '',
			scopedSlots: { customRender: 'editBtn' },
			width: 20,
		},
		{
			title: '',
			scopedSlots: { customRender: 'deleteBtn' },
			width: 20,
		}
	];
import { mapState} from 'vuex'
const data = [];
export default {
  computed: {
	  ...mapState('associations', ['associations'])
  },
components: {
			
		},
  data() {
			return {
				// Second table's list of columns.
				columns,

				data,

				// First table's number of rows per page.
				pageSize: 10,

				// Second table's number of rows per page.
				pageSize2: 10,
				
				// Second table's search query.
				query: ''

			}
		},
		methods: {
			// Event handler for first table's size change.
			onPageSizeChange() {
				this.pageSize = parseInt( this.pageSize ) ;
			},

			// Event handler for second table's size change.
			onPageSize2Change() {
				this.pageSize2 = parseInt( this.pageSize2 ) ;
			},

			

			// Event handler for second table's search.
			onSearchChange() {
				if( this.query.length > 0 ) {
					this.data = this.data.filter( (row) => {
						for( const key in row ) {
							if( String( row[key] ).toLowerCase().indexOf( this.query.toLowerCase() ) > -1 ) {
								return true;
							}
							// if( row[ key ]
							// 	.toString()
							// 	.toLowerCase()
							// 	.includes( this.query.trim().toLowerCase() ) )
							// 	return true;
						}
						return false;
					}) ;
				}
				else {
					this.data = this.associations ;
				}
			},
			
		},

created () {
    		this.$store.dispatch('associations/getAll').then(()=> {
				this.data = this.associations;
				
			})
  		}
}
</script>

<style lang="scss">
</style>